import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState, useMemo } from 'react'
import { Select, Spin } from 'antd'
import { Bar } from '@antv/g2plot'
import Card from '@/pages/Tbqy/components/components/Card'
import * as api from '@/api/tbyqy'
import { jeOptions } from '@/utils/options'
import styles from '@/pages/Tbqy/style.module.less'

const data = [];

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "本年",
    "value": 0
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "上年",
    "value": 0
  })
}

const config = {
  gr: {
    title: '签约数据统计（按签约个人）',
    tabsOptions: [
      {
        label: '签约额', 
        value: 'qygrHJ',
        api: api.getQysjtjAqygrQye
      },
      {
        label: '签约数', 
        value: 'qygrnum',
        api: api.getQysjtjAqygrQys
      },
    ],
  },
  bm: {
    title: '签约数据统计（按承担部门）',
    tabsOptions: [
      {
        label: '签约额', 
        value: 'cdbmHJ',
        api: api.getQysjtjAcdbmQye
      },
      {
        label: '签约数', 
        value: 'cdbmnum',
        api: api.getQysjtjAcdbmQys
      },
    ],
  },
  xm: {
    title: '签约数据统计（按项目类别）',
    tabsOptions: [
      {
        label: '签约额', 
        value: 'xmlbqyHJ',
        api: api.getQysjtjAxmlbQye
      },
      {
        label: '签约数', 
        value: 'xmlbqynum',
        api: api.getQysjtjAxmlbQys
      },
    ],
  },
}

type PropType = FC<PropsWithChildren<{
  updateTime: string
  type: 'gr' | 'bm' | 'xm'
}>>

const Component: PropType = ({type, updateTime}) => {
  const [loading, setLoading] = useState(false)
  const containerRef = useRef()
  const [tabValue, setTabValue] = useState(config[type].tabsOptions[0].value)
  const cfg = useMemo(() => {
    if(config[type]) {
      return config[type]
    }
    return config.gr
  }, [type])
  const globalRef = useRef({
    activeTab: cfg.tabsOptions[0].value,
    bar: null as Bar,
    je: '0',
    sfay: 'N'
  })

  useEffect(() => {
    globalRef.current.bar = new Bar(containerRef.current, {
      data,
      xField: 'value',
      yField: 'label',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      scrollbar: {
        type: 'vertical'
      }
    });

    globalRef.current.bar.render();
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = cfg.tabsOptions.find(t => t.value === globalRef.current.activeTab)
    if(!tabOption) {
      return
    }
    const res = await tabOption.api({sfay: globalRef.current.sfay})
    if(res.success) {
      if(type === 'gr') {
        let allData = res.data.list
        if(globalRef.current.activeTab === 'qygrHJ') {
          const filterFn = jeOptions.find(r => r.value === globalRef.current.je)
          if(filterFn.filter) {
            allData = allData.filter(r => filterFn.filter(r.jnHJ))
          }
        }
        globalRef.current.bar.changeData(allData.reduce((c, n) => {
          c.push({
            label: n.YWFZR,
            value: n.jnHJ || n.jngrqynum || 0,
            type: '今年'
          })
          c.push({
            label: n.YWFZR,
            value: n.qnHJ || n.qngrqynum || 0,
            type: '去年'
          })
          return c
        }, []))
      } else if(type === 'bm') {
        let allData = res.data.list
        if(globalRef.current.activeTab === 'cdbmHJ') {
          const filterFn = jeOptions.find(r => r.value === globalRef.current.je)
          if(filterFn.filter) {
            allData = allData.filter(r => filterFn.filter(r.jnHJ))
            console.log(allData)
          }
        }
        globalRef.current.bar.changeData(allData.reduce((c, n) => {
          c.push({
            label: n.NAME || n.SUO,
            value: n.jnHJ || n.jncdbmnum || 0,
            type: '今年'
          })
          c.push({
            label: n.NAME || n.SUO,
            value: n.qnHJ || n.qncdbmnum || 0,
            type: '去年'
          })
          return c
        }, []))
      } else if(type === 'xm') {
        let allData = res.data.list
        if(globalRef.current.activeTab === 'xmlbqyHJ') {
          const filterFn = jeOptions.find(r => r.value === globalRef.current.je)
          if(filterFn.filter) {
            allData = allData.filter(r => filterFn.filter(r.jnHJ))
          }
        }
        globalRef.current.bar.changeData(allData.reduce((c, n) => {
          c.push({
            label: n.XMLBMC,
            value: n.jnHJ || n.jnlbqynum || 0,
            type: '今年'
          })
          c.push({
            label: n.XMLBMC,
            value: n.qnHJ || n.qnlbqynum || 0,
            type: '去年'
          })
          return c
        }, []))
      }
      globalRef.current.bar.update(['qygrHJ', 'cdbmHJ', 'xmlbqyHJ'].includes(globalRef.current.activeTab) ? {
        xAxis: {
          label: {
            formatter: (val) => `${val} 万元`,
          }
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: datum.type,
              value: `${datum.value}万元`,
            };
          },
        }
      } : {
        xAxis: {
          label: {
            formatter: (val) => val,
          }
        },
        tooltip: {
          formatter: (datum) => {
            return {
              name: datum.type,
              value: datum.value,
            };
          },
        }
      })
    }
  }, [cfg, type])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.activeTab = value
    setTabValue(value)
    getList()
  }, [getList])

  const handleJeChange = useCallback((val) => {
    globalRef.current.je = val
    getList()
  }, [getList])

  const handleTjfw = useCallback((val) => {
    globalRef.current.sfay = val
    getList()
  }, [getList])

  useEffect(() => {
    getList()
  }, [updateTime, getList])

  return (
    <Spin spinning={loading}>
      <Card title={cfg.title} tabs={cfg.tabsOptions} onTabChange={handleTabChange}>
        <div className={`${styles['qy-bar']} flex flex-column`}>
          <div className='flex'>
            {
              ['qygrHJ', 'cdbmHJ', 'xmlbqyHJ'].includes(tabValue) && (
                <div className='mb-10'>
                  金额：<Select
                    defaultValue="0"
                    style={{width: '120px'}}
                    onChange={handleJeChange}
                    options={jeOptions}
                  />
                </div>
              )
            }
          </div>
          <div className='flex-1 h-0' ref={containerRef}></div>
        </div>
      </Card>
    </Spin>
  )
}

export default Component
